import Vue from 'vue';
import Router from 'vue-router';
import Groups from '@/components/Groups';
import GroupBatchRenew from '@/components/GroupBatchRenew';
import GroupDashboard from '@/components/GroupDashboard';
import CreateGroup from '@/components/CreateGroup';
import ManageMember from '@/components/ManageMember';
import Help from '@/components/Help';
import NotFound from '@/components/NotFound';
import Login from '@/components/Login';
import Logout from '@/components/Logout';
import { store } from '../store/store';

Vue.use(Router);

function requireAuth(to, from, next) {
  if (store.state.ticket) {
    next();
  } else {
    window.location = store.getters.casLoginServiceUrl;
  }
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Groups',
      component: Groups,
    },
    {
      path: '/group-batch-renew',
      name: 'GroupBatchRenew',
      component: GroupBatchRenew,
    },
    {
      path: '/group/:id',
      name: 'GroupDashboard',
      component: GroupDashboard,
      props: true,
    },
    {
      path: '/createGroup/:stem?',
      name: 'CreateGroup',
      component: CreateGroup,
      props: true,
    },
    {
      path: '/manageMember',
      name: 'ManageMember',
      component: ManageMember,
    },
    {
      path: '/login/cas',
      redirect: (to) => {
        if (to.query.ticket) {
          return { name: 'Login' };
        }
        return { name: 'Logout' };
      },
      props: route => ({ query: route.query.q }),
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
    },
    {
      path: '*',
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const whitelisted = ['/login/cas', '/login', '/logout'];
  if (whitelisted.includes(to.path)) {
    next();
  } else {
    // Cookie that is used for resuming a session when a user is forced to re-authenticate due to an expired token.
    Vue.$cookies.set('current_path', to.path);
    requireAuth(to, from, next);
  }
});


export default router;




// WEBPACK FOOTER //
// ./src/router/index.js